import React from "react";



const NotFound = () => {
  return (
    <>
      <div className="text-center">
        <h1>404</h1>
        <h1>NOT FOUND</h1>
        <p>There's nothing to see here.</p>
      </div>
    </>
  );
};

export default NotFound;
